import { useState } from 'react';
import PlusSolidIcon from '../../icons/solid/plus-solid';

const AddItemChip = ({ title, onClick }: { title: string; onClick: () => void }): JSX.Element => {
    const [showFullInfo, setShowFullInfo] = useState<boolean>(false);
    return (
        <button className="absolute bottom-0 right-0" onClick={onClick}>
            {!showFullInfo ? (
                <div
                    className={`w-20 h-20 bg-neutral-8 min-w-20 min-h-20 flex items-center justify-center cursor-pointer`}
                    onMouseEnter={() => setShowFullInfo(true)}
                >
                    <PlusSolidIcon className="w-14 h-14 text-actionPrimary" />
                </div>
            ) : null}
            {showFullInfo ? (
                <div
                    className="space-x-4 flex items-center bg-neutral-8 px-8 cursor-pointer"
                    onMouseLeave={() => setShowFullInfo(false)}
                >
                    <PlusSolidIcon className="w-14 h-14 text-actionPrimary" />
                    <p className="text-actionPrimary font-700 text-12">{title}</p>
                </div>
            ) : null}
        </button>
    );
};

export default AddItemChip;
